import { apiGet, apiPost, apiPut, apiDelete } from "./client.js";

const BASE = "/api/v1/test-cases";

// Add `id` alias for `_id` so old UI code that uses `tc.id` works
const addId = (item) => item ? { ...item, id: item._id } : item;
const addIds = (items) => (items || []).map(addId);

export const listTestCases = () => apiGet(BASE).then((d) => addIds(d.testCases));
export const getTestCase = (id) => apiGet(`${BASE}/${id}`).then(addId);
export const createTestCase = (data) => apiPost(BASE, data).then(addId);
export const updateTestCase = (id, data) => apiPut(`${BASE}/${id}`, data).then(addId);
export const deleteTestCase = (id) => apiDelete(`${BASE}/${id}`);
export const listVersions = (id) => apiGet(`${BASE}/${id}/versions`);
export const getVersion = (id, ver) => apiGet(`${BASE}/${id}/versions/${ver}`);
export const restoreVersion = (id, ver) => apiPost(`${BASE}/${id}/versions/${ver}/restore`, {});
